import {tv} from 'tailwind-variants'

export const comparisonTableVariants = tv({
  slots: {
    row: 'grid w-full grid-cols-2 border-b-0 border-border-frosted md:grid-cols-3 md:divide-x xl:grid-cols-[2fr_1fr_1fr] [&_td:last-of-type]:border-l [&_th:last-of-type]:border-l',
    bodyCellWrapper:
      'col-span-1 border-t border-solid border-border-frosted px-s4 py-s3 md:border-t-0 md:border-dashed',
    bodyCellContent: '',
    innerCellTextContent: 'items-center',
  },
  variants: {
    variant: {
      rowTitle: {
        bodyCellWrapper:
          'col-span-2 border-b-0 border-t-0 border-solid md:col-span-1 ',
        bodyCellContent: 'md:justify-start md:text-left',
      },
      total: {
        bodyCellWrapper: 'px-s5 py-s5',
      },
    },
    type: {
      empty: {
        bodyCellWrapper: 'hidden md:block',
      },
      text: '',
    },
  },
})
